import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { useStore } from 'vuex';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AvaliateMaterialsButton',
    setup(__props) {
        const store = useStore();
        const openModal = () => {
            setTimeout(() => {
                store.dispatch('setModalData', { modalName: 'AvaliateMaterialsModal', modalWrapperDiv: '.avaliate-materials-wrapper' });
            }, 0);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("button", {
                class: "border-0 d-flex align-items-center justify-content-center rounded-3 avaliate-button position-fixed z-3",
                onClick: openModal
            }, [...(_cache[0] || (_cache[0] = [
                    _createElementVNode("i", { class: "bi text-white fs-5 bi-star-fill" }, null, -1)
                ]))]));
        };
    }
});
